import axios from "axios";
import { Token_Name } from "../common/constants";
import { parseJSON } from "../common/helperFunctions";
import { authModel } from "../models/Auth.model";
import authHeader from "./auth-header";
const API_URL = "/account/";

const verifyCode = (emailAddress: string, code: string, token: string) => {
  return axios
    .post(API_URL + "verifyCode", {
      emailAddress,
      code,
      token
    })
    .then((response) => {
      if (response.data) {
        localStorage.setItem(Token_Name, JSON.stringify(response.data));
      }
      return response.data;
    });
};

const login = (emailAddress: string, password: string) => {
  return axios
    .post(API_URL + "signin", {
      emailAddress,
      password,
    })
    .then((response) => {
      if (response.data) {
        localStorage.setItem(Token_Name, JSON.stringify(response.data));
      }
      return response.data;
    });
};

const changePassword = (currentPassword: string, newPassword: string) => {
  return fetch(API_URL + "ChangePassword", authHeader("POST", JSON.stringify({
        currentPassword,
        newPassword,
      }), ''))
        .then(response => {
          if (!response.ok) {
            throw new Error('Unable to save');
          }
          return response;
        });

};

const logout = () => {
  localStorage.removeItem(Token_Name);
};

const getCurrentUser = (): authModel => {
  const userStr = localStorage.getItem(Token_Name);
  const today = new Date();
  if (userStr === null) {
    return {
      accessToken:'',
      token:'',
      firstName:'',
      lastName:'',
      expiry: today,
      forceChangePassword: ''
    }
  }
  const user = parseJSON(userStr);

  if (user.expiry <= today){
    logout();
  }

  return user;
};

const AuthService = {
  login,
  verifyCode,
  logout,
  getCurrentUser,
  changePassword,
};
export default AuthService;